import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { PercentileLevel } from '@talentmesh/utils';
import ScoreConnector from './ScoreConnector';

interface TestScoreProps {
    label: string;
    scoreLevel?: PercentileLevel;
    scoreValue?: number;
    talentScore?: boolean;
}

const MainCircleSize = 96;
const RegularCircleSize = 54;
const ConnectorLength = 36;

function TestScore({ label, scoreLevel, scoreValue, talentScore }: TestScoreProps) {
    return (
        <div
            className="flex flex-col items-end gap-3"
            style={{ marginTop: talentScore ? 0 : `${MainCircleSize / 2 - RegularCircleSize / 2}px` }}
        >
            <div className="flex flex-row items-center">
                <div className="flex flex-col justify-center" style={{ width: talentScore ? 0 : ConnectorLength }}>
                    {!talentScore && <ScoreConnector />}
                </div>
                <div className="flex flex-col" style={{ width: talentScore ? MainCircleSize : RegularCircleSize }}>
                    <AnimatedCircularProgressBar
                        value={scoreValue}
                        level={scoreValue ? scoreLevel : undefined}
                        className={talentScore ? 'size-24 text-xl' : 'size-13.5 text-base'}
                    />
                </div>
            </div>
            <div
                className="flex flex-col items-center"
                style={{
                    marginLeft: talentScore ? 0 : `${ConnectorLength}px`,
                    width: talentScore ? `${MainCircleSize}px` : `${RegularCircleSize}px`,
                }}
            >
                <h6 className="text-foreground text-center text-xs font-bold">{label}</h6>
            </div>
        </div>
    );
}

export default TestScore;
